import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";



import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import Button from '@mui/joy/Button';

import { getIcon } from "utils/misc";
import { Identity } from "stores/identity_store";

import useIdentity from "hooks/useIdentity";
import useUserIdentity from "hooks/useUserIdentity";
import useWorkKey from 'hooks/useWorkKey';
import useDedicitedAssignment from "hooks/useDedicatedAssignment";




function YouAreDedicated({identity}: {identity: Identity}) {
    const navigate = useNavigate();
    return (
        <Stack>
            <Typography>
                You are the dedicated assistant for this person
            </Typography>
            <Stack direction="row">

        <Button onClick={() => navigate(`/dedicated/${identity.uuid}`)}>View Dedicated</Button>
    </Stack>
        </Stack>
    );
}

function ThisIsYourDedicated() {
    return (
        <Stack
            margin={2}
            padding={2}
            borderTop={0}
            borderColor="divider">
            <Typography level="title-lg">This is your dedicated assistant</Typography>
        </Stack>
    );
}


const IdentityPageDedicatedAssistant = observer(({ identityKey }: { identityKey: string }) => {
    const { getIdentity } = useIdentity();
    const { currentIdentity } = useUserIdentity();
    const workKey = useWorkKey();
    const { getDedicatedAssignmentsByIdentity,
        fetchDedicatedAssignmentsByIdentity, isDedicatedFor } =
        useDedicitedAssignment();

    const dedicatedAssignments = getDedicatedAssignmentsByIdentity(identityKey);
    const [thisIsYourDedicated, setThisIsYourDedicated] = useState(false);

    const identity = getIdentity(identityKey);
    const DedicatedIcon = getIcon('Person');

    const youAreDedicated = dedicatedAssignments.find((a) => a.assistant_identity == currentIdentity.key);

    useEffect(() => {
        fetchDedicatedAssignmentsByIdentity(workKey, identityKey);
    }, [workKey, identityKey, fetchDedicatedAssignmentsByIdentity]);

    useEffect(() => {
        if (isDedicatedFor(identityKey, currentIdentity.key)) {
            setThisIsYourDedicated(true);
        }
    }, [isDedicatedFor, identityKey, currentIdentity.key]);

    if (!identity)
        return null;

    // we're looking at a dedicated assistant
    if (identity.role == 'assistant' && identity.dedicated) {
        return (
            <Stack padding={1}>
                <Typography
                    startDecorator={<DedicatedIcon />}
                    level="body-xs">This is a dedicated assistant</Typography>

                {thisIsYourDedicated &&
                    <ThisIsYourDedicated />
                }
            </Stack>
        );
    }

    else {
        if (youAreDedicated) {
            return (
                <YouAreDedicated identity={identity} />
            );
        }
        else {
            return null;
        }
    }





});

export default IdentityPageDedicatedAssistant;
